import { IApplicationState } from '../../types/redux';

export function seoCrossLinksReducer(state: IApplicationState['crossLinks'] = null): IApplicationState['crossLinks'] {
  return state;
}
